import { Component, computed, effect, input } from "@angular/core";
import { TiltakButton } from "../tiltak-button/tiltak-button";
import { Tiltak } from "../../../../models/oppsummering.model";

@Component({
  selector: "bko-anbefaling-card",
  imports: [TiltakButton],
  templateUrl: "./anbefaling-card.html",
  styleUrl: "./anbefaling-card.scss",
})
export class AnbefalingCard {
  tiltakListe = input<Tiltak[]>([]);
  besvarelseId = input<string>();
  antallTiltak = computed(() => this.tiltakListe().length);


  constructor() {
  }
}
